module.exports = __webpack_public_path__ + "static/group-3@2x-69843773cec3fdcd179875d33722bb8f.png";